import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded';
import Grid from '@mui/material/Grid';
import { PageHeader } from 'components/ui/Global/PageHeader';
import { useTranslation } from 'react-i18next';
import { Outlet, useParams } from 'react-router-dom';
import { TicketHeaderButtonDetails } from './Components/TicketStyleConfig';

export const Ticket = () => {
  const { t } = useTranslation();

  /* INITIALIZATIONS */
  const { ticketId } = useParams();

  // api

  if (ticketId === undefined) {
    return null;
  }
  const TicketHeaderLinks = TicketHeaderButtonDetails(ticketId, null).map(
    (button) => ({
      ...button,
      name: t(button.name), // Localize the name here
    })
  );

  return (
    <Grid container direction='row' spacing={0}>
      <Grid item xs={12} sx={{}}>
        <PageHeader
          Icon={SupportAgentRoundedIcon}
          title='Tickets'
          FormJSX={null}
          HeaderButtons={TicketHeaderLinks}
        />
      </Grid>
      <Grid item xs={12} sx={{}}>
        <Outlet />
      </Grid>
    </Grid>
  );
};
